import { generateUTCDate } from "../Date";
import { getMatch } from "../CommonParsers";
import { seriesRegex, validityRegex } from "./SigmetRegExp";
import { IValidity } from "@naviair-utm/node-shared-interfaces";
import moment from "moment";

/**
 * A parser to get the series this sigmet is part of and the index in the series
 * @param input The sigmet message
 * @returns Object with a series string and the index of this message
 */
export const seriesParser = (
  input: string
): { series: string; seriesIndex: number } | null => {
  const seriesMatch: RegExpMatchArray | null = input.match(seriesRegex);
  if (seriesMatch !== null) {
    // Get the index of this sigmet in the series
    const seriesIndex = parseInt(getMatch(seriesMatch, 2));
    if (!isNaN(seriesIndex) && seriesIndex > 0) {
      // If the index is a number, then get the series name and return the object
      return {
        series: getMatch(seriesMatch),
        seriesIndex: seriesIndex,
      };
    } else {
      // Something is wrong, return null
      return null;
    }
  } else {
    return null;
  }
};

/**
 * Get the validity of the sigmet message
 * @param input The sigmet message
 * @returns Object with start and end of the validity
 */
export const validityParser = (input: string): IValidity | undefined => {
  const validityMatch: RegExpMatchArray | null = input.match(validityRegex);
  if (validityMatch !== null) {
    // Check if index 3 is set, else if 1 and 2 is set
    if (validityMatch[3] && !isNaN(parseInt(validityMatch[3]))) {
      // The format is "VALID UNTIL xxxx"
      const end = getMatch(validityMatch, 3);
      const endObj = {
        day: parseInt(end.substr(0, 2)),
        hour: parseInt(end.substr(2, 2)),
        minute: parseInt(end.substr(4, 2)),
      };
      // It is active now
      const startDate = moment.utc();
      const endDate = generateUTCDate(endObj.minute, endObj.hour, endObj.day);

      return { start: startDate.toDate(), end: endDate.toDate() };
    } else if (validityMatch[1] && validityMatch[2]) {
      // The format is "VALID xxxx/xxxx"
      // match[1] is the start and match[2] is the end, cf. regex
      const start = getMatch(validityMatch, 1);
      const end = getMatch(validityMatch, 2);

      // Start and end must be 2 numeric strings
      if (!isNaN(parseInt(start)) && !isNaN(parseInt(end))) {
        const startObj = {
          day: parseInt(start.substr(0, 2)),
          hour: parseInt(start.substr(2, 2)),
          minute: parseInt(start.substr(4, 2)),
        };

        const endObj = {
          day: parseInt(end.substr(0, 2)),
          hour: parseInt(end.substr(2, 2)),
          minute: parseInt(end.substr(4, 2)),
        };

        const startDate = generateUTCDate(
          startObj.minute,
          startObj.hour,
          startObj.day
        );
        const endDate = generateUTCDate(endObj.minute, endObj.hour, endObj.day);

        return { start: startDate.toDate(), end: endDate.toDate() };
      }
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};
